export default __webpack_public_path__ + "static/1329-2f9a942a4de3d81cbe0732c49eea3b08.gif";